module.exports = __webpack_public_path__ + "static/icons/icon-alert-6b0741ad4fc50640091405d434f700ca.svg";